import type { Entity, TrackingContextValue } from '@ps/web-shared-analytics';
import { getEntities } from '@ps/web-shared-analytics';
import { keyBy, merge, values } from 'lodash';

const mergeWithExistingTrackingEntities = (
  trackingContext: TrackingContextValue,
  entities: Entity[]
): Entity[] => {
  const existingEntities = getEntities(trackingContext);

  return values(merge(keyBy(existingEntities, 'schema'), keyBy(entities, 'schema')));
};

const mergeWithTrackingContextValue = (
  trackingContext: TrackingContextValue,
  entities: Entity[]
): TrackingContextValue => ({
  ...trackingContext,
  entities: mergeWithExistingTrackingEntities(trackingContext, entities)
});

export default mergeWithTrackingContextValue;
